import { render, staticRenderFns } from "./BatchesProtocolsReport.vue?vue&type=template&id=63dbdd84"
import script from "./BatchesProtocolsReport.vue?vue&type=script&lang=js"
export * from "./BatchesProtocolsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports